import { FC } from "react";

type IProps = {
  stroke: string;
  width: number;
  height: number;
};

const Catalog: FC<IProps> = ({
  stroke = "#BEBEBE",
  width = 18,
  height = 18,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        fill={stroke}
        d="M24 24v2h2.46A5.94 5.94 0 0122 28a6.007 6.007 0 01-6-6h-2a7.985 7.985 0 0014 5.265V30h2v-6h-6zm-2-10a8.041 8.041 0 00-6 2.735V14h-2v6h6v-2h-2.46A5.94 5.94 0 0122 16a6.007 6.007 0 016 6h2a8.01 8.01 0 00-8-8z"
      ></path>
      <path
        fill={stroke}
        d="M12 28H6v-4h2v-2H6v-5h2v-2H6v-5h2V8H6V4h18v8h2V4a2 2 0 00-2-2H6a2 2 0 00-2 2v4H2v2h2v5H2v2h2v5H2v2h2v4a2 2 0 002 2h6v-2z"
      ></path>
    </svg>
  );
};

export default Catalog;
